import { CFBaseButtonTokens, CFBaseButtonUtils } from '../';
import { css } from 'styled-components';
export const wrapperWidth = ({ $iconOnly, $size = 'md', $variant, $widthPreset, }) => {
    const isVariantStandaloneType = CFBaseButtonUtils.isVariantStandaloneType($variant);
    // When iconOnly, width should be same as height to force a square/circular button; otherwise we use max-content
    const width = $iconOnly && !isVariantStandaloneType
        ? `${CFBaseButtonTokens.HEIGHT[$size]}px`
        : 'auto';
    switch ($widthPreset) {
        case 'min-160':
            return css `
        min-width: 160px;
      `;
        case 'full':
            return css `
        width: 100%;
        flex: auto 1;
      `;
        case 'half':
            return css `
        width: 50%;
        flex: auto 0.5;
      `;
        default:
            return css `
        width: ${width};
      `;
    }
};
